import { render, staticRenderFns } from "./CentroOncologiaComponente.vue?vue&type=template&id=4a544dec&scoped=true"
import script from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
export * from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroOncologiaComponente.vue?vue&type=style&index=0&id=4a544dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a544dec",
  null
  
)

export default component.exports